import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import _ from 'lodash'

import { DynamicListService } from '../../service/dynamic-list.service';
import { take } from 'rxjs/operators';

@Component({
  styles: [''],
  selector: 'app-institute-dyn-list-item-modal',
  templateUrl: './institute-dyn-list-item-modal.component.html',
})
export class InstDynListItemModalComponent implements OnInit {
	@Input() dynamicListItems: any[] = [];
	@Input() closable: boolean = false;

	@Output() save = new EventEmitter();

	allDynamicListItems: any[] = [];
	count: number = 0;

	saved: boolean;
	display: boolean;
	loadedDynamicListItems: boolean;

	sourceDynamicListItems: any[] = [];
	targetDynamicListItems: any[] = [];

	constructor(private dynamicListService: DynamicListService) {}

	ngOnInit() {}

	onClose() {}

	onOpen() {
    if (this.existDynamicListItems()) {
      this.display = true;
    }

		this.getDynamicListItems();
	}

	cleanValues() {
		this.sourceDynamicListItems = [];
		this.targetDynamicListItems = [];

		this.loadedDynamicListItems = false;
	}
	
	onSave() {
		this.save.emit({ dynamicListItems: this.targetDynamicListItems });

		this.saved = true;
		this.display = false;
	}

	existDynamicListItems = () => this.allDynamicListItems.length > 0;

	async getDynamicListItems(forceReload = false) {
		if (forceReload || !this.existDynamicListItems()) {
			this.loadedDynamicListItems = false;

			this.dynamicListService.getItemsPaginated({ init: 0, end: 1e+8 })
		 	.pipe(take(1)).subscribe(result => {
			 if (result) {
				 this.count = result['count'] || 0;
				 this.allDynamicListItems = result['rows'];
			 } else console.error('Sem dados ao obter os dynamicListItems');

			 this.buildDynamicListItems();
		 });
		} else this.buildDynamicListItems();
	}

	async buildDynamicListItems() {
		this.cleanValues();

		if (this.allDynamicListItems.length) {
			this.allDynamicListItems.forEach((dynListItem) => {
				if (dynListItem && dynListItem.dyn_list_field_raw_resp.length) {
					dynListItem.fullName = dynListItem.dyn_list_field_raw_resp.map(({ value, id }) => value || id).join(' - ');

					if (this.dynamicListItems.some(({ dyn_list_item_id: id }) => id == dynListItem.id)) {
						this.targetDynamicListItems.push(dynListItem);
					} else {
						this.sourceDynamicListItems.push(dynListItem);
					}
				} else console.info('Dynamic List Item without dyn_list_field_raw_resp');
			})

			this.display = true;
			this.loadedDynamicListItems = true;
		} else console.info('Empty Dynamic List Items.');
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/institute-dyn-list-item-modal/institute-dyn-list-item-modal.component.ts